<div class="project__editor-bar">
  @if (!exportMode) {
    <div class="project__editor-bar-status">
      @if (lockedByOwnerDraft) {
        <span class="project__draft-badge">{{ 'project.draft.lockedBadge' | translate }}</span>
        <span class="project__locked-hint">{{ 'project.draft.lockedHint' | translate }}</span>
      } @else if (canSaveDraft && isDraft) {
        <span class="project__draft-badge">{{ 'project.draft.badge' | translate }}</span>
        @if (draftSavedAt) {
          <span class="project__draft-saved">{{
            'project.draft.savedAt' | translate: { date: (draftSavedAt | date: 'dd.MM.yyyy, HH:mm') }
          }}</span>
        }
      }
      @if (editMode && unsavedHead) {
        <span class="project__head-unsaved">{{ 'project.unsaved' | translate }}</span>
      }
    </div>
  }
  <div class="project__save-actions">
    @if (!exportMode && !editMode && canDiscardDraft) {
      <button mat-stroked-button type="button" class="project__discard-button" [disabled]="isSaving" (click)="discardDraft.emit()">
        {{ 'project.draft.discard' | translate }}
      </button>
    }
    <button
      mat-stroked-button
      type="button"
      class="project__delete-project-button"
      [disabled]="lockedByOwnerDraft"
      [matTooltip]="lockedByOwnerDraft ? ('project.draft.lockedHint' | translate) : ''"
      (click)="deleteProjekt()"
    >
      <mat-icon aria-hidden="true">delete</mat-icon>
      {{ 'project.button.deleteProject' | translate }}
    </button>
    @if (!exportMode) {
      @if (editMode) {
        <ng-container *ngTemplateOutlet="saveButtons"></ng-container>
      } @else if (isSaving) {
        <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
      } @else {
        <button
          mat-stroked-button
          type="button"
          class="project__edit-button"
          [disabled]="lockedByOwnerDraft"
          [matTooltip]="lockedByOwnerDraft ? ('project.draft.lockedHint' | translate) : ''"
          (click)="onToggleEdit()"
        >
          {{ 'general.edit' | translate }}
        </button>
      }
    }
  </div>
</div>
<mat-card appearance="outlined" class="project__card" [class.project__card--editing]="editMode">
  <mat-card-content>
    <form
      #projectForm="ngForm"
      [class.invalid-form]="projectForm.invalid"
      (ngSubmit)="save(projectForm)"
    >
      @if (isNewProject) {
        <div class="project__wrapper">
          <h1 class="project__headline">
            {{ 'project.newProjectHeadline' | translate }}
          </h1>
        </div>
      }
      <div class="project__content">
        <div>
          <h4 class="project__headline">
            {{ 'project.projectQuestion' | translate }}
          </h4>
          @if (!editMode) {
            <p>
              {{ 'project.textPartOne' | translate }}
              <span class="project__date">{{ projekt?.beginn | date: 'MM/yyyy' }}</span>
              <ng-container
                *ngTemplateOutlet="fieldWarning; context: { $implicit: fieldFinding('beginn') }"
              ></ng-container>
              {{ 'project.textPartTwo' | translate }}
              @if (projekt?.ende) {
                <span class="project__date">{{ projekt.ende | date: 'MM/yyyy' }}</span>
              } @else {
                {{ 'project.textPartThree' | translate }}
              }
              {{ 'project.textPartFour' | translate }}"{{
                projekt.projektname
              }}"
              <ng-container
                *ngTemplateOutlet="fieldWarning; context: { $implicit: fieldFinding('projektname') }"
              ></ng-container>
              {{ 'project.textPartFive' | translate }}
              {{ projekt?.kunde }}
              <ng-container
                *ngTemplateOutlet="fieldWarning; context: { $implicit: fieldFinding('kunde') }"
              ></ng-container>
              {{ 'project.textPartSix' | translate }}
              {{ projekt?.stelle }}
              <ng-container
                *ngTemplateOutlet="fieldWarning; context: { $implicit: fieldFinding('stelle') }"
              ></ng-container>
              {{ 'project.textPartSeven' | translate }}
            </p>
          } @else {
            <p>
              {{ 'project.textPartOne' | translate }}
              <mat-form-field>
                <mat-label>{{ 'project.textPartOne' | translate }}</mat-label>
                <input
                  matInput
                  required
                  name="beginn"
                  [matDatepicker]="picker"
                  [(ngModel)]="projectLocal.beginn"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker>
                  <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>
                      {{ 'general.cancel' | translate }}
                    </button>
                    <button mat-flat-button matDatepickerApply>
                      {{ 'general.apply' | translate }}
                    </button>
                  </mat-datepicker-actions>
                </mat-datepicker>
              </mat-form-field>
              {{ 'project.textPartTwo' | translate }}
              <mat-form-field>
                <mat-label>{{ 'project.textPartTwo' | translate }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="datepicker"
                  [(ngModel)]="projectLocal.ende"
                  name="ende"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="datepicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #datepicker>
                  <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>
                      {{ 'general.cancel' | translate }}
                    </button>
                    <button mat-flat-button matDatepickerApply>
                      {{ 'general.apply' | translate }}
                    </button>
                  </mat-datepicker-actions>
                </mat-datepicker>
              </mat-form-field>
              {{ 'project.textPartFour' | translate }}
              <mat-form-field>
                <mat-label>{{
                  'project.projectNameLabel' | translate
                }}</mat-label>
                <input
                  required
                  matInput
                  type="text"
                  [(ngModel)]="projectLocal.projektname"
                  name="projektname"
                  appTrimmedLength
                  [maxlength]="LIMITS.SHORT_LABEL"
                  #projektname="ngModel"
                />
                <mat-hint align="end">{{ (projectLocal.projektname?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
                @if (projektname.errors?.['required']) {
                  <mat-error>{{
                    'general.errors.required' | translate
                  }}</mat-error>
                }
                @if (projektname.errors?.['maxlength']) {
                  <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
                }
              </mat-form-field>
              {{ 'project.textPartFive' | translate }}
              <span class="project__inline-field field-hint-anchor">
                <span class="field-hint-corner">
                  <ng-container
                    *ngTemplateOutlet="fieldInfo; context: { $implicit: 'tooltip.projectCompany' }"
                  ></ng-container>
                </span>
                <mat-form-field>
                  <mat-label>{{
                    'project.projectCompanyLabel' | translate
                  }}</mat-label>
                  <input
                    required
                    matInput
                    type="text"
                    [(ngModel)]="projectLocal.kunde"
                    name="kunde"
                    appTrimmedLength
                    [maxlength]="LIMITS.SHORT_LABEL"
                    #kunde="ngModel"
                  />
                  <mat-hint align="end">{{ (projectLocal.kunde?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
                  @if (kunde.errors?.['required']) {
                    <mat-error>{{
                      'general.errors.required' | translate
                    }}</mat-error>
                  }
                  @if (kunde.errors?.['maxlength']) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
                  }
                </mat-form-field>
              </span>
              {{ 'project.textPartSix' | translate }}
              <mat-form-field>
                <mat-label>{{
                  'project.projectPositionLabel' | translate
                }}</mat-label>
                <input
                  required
                  matInput
                  type="text"
                  [(ngModel)]="projectLocal.stelle"
                  name="stelle"
                  appTrimmedLength
                  [maxlength]="LIMITS.SHORT_LABEL"
                  #stelle="ngModel"
                />
                <mat-hint align="end">{{ (projectLocal.stelle?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
                @if (stelle.errors?.['required']) {
                  <mat-error>{{
                    'general.errors.required' | translate
                  }}</mat-error>
                }
                @if (stelle.errors?.['maxlength']) {
                  <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
                }
              </mat-form-field>
              {{ 'project.textPartSeven' | translate }}
            </p>
          }
        </div>
        <div>
          <h4 class="project__headline">
            {{ 'project.projectInformation' | translate }}
          </h4>
          <div class="project__info">
            <div class="project__key-figure">
              @if (!editMode) {
                <div class="project__label-row">
                  <mat-label class="project__headline">{{
                    'project.projectIndustries' | translate
                  }}</mat-label>
                  <ng-container
                    *ngTemplateOutlet="fieldWarning; context: { $implicit: fieldFinding('branchNames'), align: 'start' }"
                  ></ng-container>
                </div>
                @for (industry of projekt?.branchNames; track industry.id) {
                  <p>{{ industry | vocabulary:'industry' }}</p>
                }
              } @else {
                <app-industries-dropdown
                  [showSorting]="false"
                  [required]="true"
                  [invalid]="!hasIndustries"
                  [errorText]="'project.error.industriesRequired' | translate"
                  (industriesChange)="onProjectIndustriesChanged($event)"
                  [availableIndustries]="cachedIndustries"
                  [selectedIndustries]="selectedIndustryNames"
                >
                </app-industries-dropdown>
              }
            </div>
            <div class="project__key-figure" [class.field-hint-anchor]="editMode">
              @if (!editMode) {
                <div class="project__label-row">
                  <mat-label class="project__headline">{{
                    'project.projectSize' | translate
                  }}</mat-label>
                  <ng-container
                    *ngTemplateOutlet="fieldInfo; context: { $implicit: 'tooltip.teamSize', align: 'start' }"
                  ></ng-container>
                  <ng-container
                    *ngTemplateOutlet="fieldWarning; context: { $implicit: fieldFinding('teamSize'), align: 'start' }"
                  ></ng-container>
                </div>
                <p>{{ projekt?.teamSize }}</p>
              } @else {
                <span class="field-hint-corner">
                  <ng-container
                    *ngTemplateOutlet="fieldInfo; context: { $implicit: 'tooltip.teamSize' }"
                  ></ng-container>
                </span>
                <mat-form-field>
                  <mat-label>{{ 'project.projectSize' | translate }}</mat-label>
                  <input
                    required
                    matInput
                    type="number"
                    [(ngModel)]="projectLocal.teamSize"
                    name="teamSize"
                    min="1"
                    #teamSize="ngModel"
                  />
                  @if (teamSize.errors?.['required']) {
                    <mat-error>{{
                      'general.errors.required' | translate
                    }}</mat-error>
                  } @else if (teamSize.errors?.['min']) {
                    <mat-error>{{ 'project.error.teamSizePositive' | translate }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>
            <div class="project__key-figure" [class.field-hint-anchor]="editMode">
              @if (!editMode) {
                <div class="project__label-row">
                  <mat-label class="project__headline">{{
                    'project.projectTester' | translate
                  }}</mat-label>
                  <ng-container
                    *ngTemplateOutlet="fieldInfo; context: { $implicit: 'tooltip.testerCount', align: 'start' }"
                  ></ng-container>
                  <ng-container
                    *ngTemplateOutlet="fieldWarning; context: { $implicit: fieldFinding('numberTester'), align: 'start' }"
                  ></ng-container>
                </div>
                <p>{{ projekt?.numberTester }}</p>
              } @else {
                <span class="field-hint-corner">
                  <ng-container
                    *ngTemplateOutlet="fieldInfo; context: { $implicit: 'tooltip.testerCount' }"
                  ></ng-container>
                </span>
                <mat-form-field>
                  <mat-label>{{ 'project.projectTester' | translate }}</mat-label>
                  <input
                    required
                    matInput
                    type="number"
                    [(ngModel)]="projectLocal.numberTester"
                    name="numberTester"
                    min="0"
                    #numberTester="ngModel"
                  />
                  @if (numberTester.errors?.['required']) {
                    <mat-error>{{
                      'general.errors.required' | translate
                    }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>
            <div class="project__key-figure" [class.field-hint-anchor]="editMode">
              @if (!editMode) {
                <div class="project__label-row">
                  <mat-label class="project__headline">{{
                    'project.projectTotalSize' | translate
                  }}</mat-label>
                  <ng-container
                    *ngTemplateOutlet="fieldInfo; context: { $implicit: 'tooltip.overallProjectSize', align: 'start' }"
                  ></ng-container>
                  <ng-container
                    *ngTemplateOutlet="fieldWarning; context: { $implicit: fieldFinding('projectSize'), align: 'start' }"
                  ></ng-container>
                </div>
                <p>{{ projekt?.projectSize }}</p>
              } @else {
                <span class="field-hint-corner">
                  <ng-container
                    *ngTemplateOutlet="fieldInfo; context: { $implicit: 'tooltip.overallProjectSize' }"
                  ></ng-container>
                </span>
                <mat-form-field>
                  <mat-label>{{
                    'project.projectTotalSize' | translate
                  }}</mat-label>
                  <input
                    matInput
                    type="number"
                    [(ngModel)]="projectLocal.projectSize"
                    name="projectSize"
                    min="0"
                  />
                </mat-form-field>
              }
            </div>
            <div class="project__key-figure" [class.field-hint-anchor]="editMode">
              @if (!editMode) {
                <div class="project__label-row">
                  <mat-label class="project__headline">{{
                    'project.projectDeploymentLocation' | translate
                  }}</mat-label>
                  <ng-container
                    *ngTemplateOutlet="fieldInfo; context: { $implicit: 'tooltip.workLocation', align: 'start' }"
                  ></ng-container>
                  <ng-container
                    *ngTemplateOutlet="fieldWarning; context: { $implicit: fieldFinding('workLocation'), align: 'start' }"
                  ></ng-container>
                </div>
                <p>{{ projekt?.workLocation }}</p>
              } @else {
                <span class="field-hint-corner">
                  <ng-container
                    *ngTemplateOutlet="fieldInfo; context: { $implicit: 'tooltip.workLocation' }"
                  ></ng-container>
                </span>
                <mat-form-field>
                  <mat-label>{{
                    'project.projectDeploymentLocation' | translate
                  }}</mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="projectLocal.workLocation"
                    name="workLocation"
                    [maxlength]="LIMITS.LOCATION"
                    #workLocation="ngModel"
                  />
                  @if (workLocation.errors?.['maxlength']) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.LOCATION } }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>
          </div>
        </div>
        <div>
          <div class="project__label-row">
            <h4 class="project__headline">
              {{ 'project.projectDescription' | translate }}
            </h4>
            <ng-container
              *ngTemplateOutlet="fieldInfo; context: { $implicit: 'tooltip.projectDescription', align: 'start' }"
            ></ng-container>
            @if (!editMode) {
              <ng-container
                *ngTemplateOutlet="fieldWarning; context: { $implicit: fieldFinding('beschreibung'), align: 'start' }"
              ></ng-container>
            }
          </div>
          @if (!editMode) {
            <p>{{ projekt?.beschreibung }}</p>
          } @else {
            <mat-form-field class="project__desc">
              <mat-label>{{
                'project.projectDescription' | translate
              }}</mat-label>
              <textarea
                required
                matInput
                type="text"
                name="beschreibung"
                [(ngModel)]="projectLocal.beschreibung"
                appTrimmedLength
                [appTrimmedMin]="LIMITS.PROJECT_DESCRIPTION_MIN"
                [maxlength]="LIMITS.PROJECT_DESCRIPTION"
                (blur)="onDescriptionBlur()"
                cdkTextareaAutosize
                cdkAutosizeMinRows="5"
                cdkAutosizeMaxRows="15"
                #beschreibungModel="ngModel"
              >
              </textarea>
              @if (
                beschreibungModel.errors?.minlength && beschreibungModel.touched
              ) {
                <mat-error>
                  {{ 'project.validation.minLength' | translate }}
                </mat-error>
              } @else if (
                beschreibungModel.errors?.required && beschreibungModel.touched
              ) {
                <mat-error>
                  {{ 'project.validation.beschreibung.missing' | translate }}
                </mat-error>
              }
              <mat-hint
                align="end"
                [class.project__hint--error]="
                  trimmedLength(projectLocal?.beschreibung) < LIMITS.PROJECT_DESCRIPTION_MIN
                "
              >
                {{ trimmedLength(projectLocal?.beschreibung) }}/{{
                  trimmedLength(projectLocal?.beschreibung) < LIMITS.PROJECT_DESCRIPTION_MIN ? LIMITS.PROJECT_DESCRIPTION_MIN : LIMITS.PROJECT_DESCRIPTION
                }}
              </mat-hint>
            </mat-form-field>
          }
        </div>

        <div>
          <h4 class="project__headline">
            {{ 'project.methodology' | translate }}
          </h4>
          @if (exportMode && twoPagerMode) {
            @for (methodik of projectLocal.methodik; track methodik) {
              <div class="project__export-row">
                @if (exportable) {
                <mat-checkbox
                  [checked]="selectedMethodIds.includes(methodik)"
                  [disabled]="!canSelectMethod(methodik)"
                  (change)="toggleMethodExport(methodik, $event.checked)"
                  (click)="$event.stopPropagation()"
                ></mat-checkbox>
                }
                <span>{{ methodik | vocabulary:'method' }}</span>
              </div>
            }
          } @else if (!editMode) {
            <p>
              @for (
                methodik of projectLocal.methodik;
                track methodik;
                let idx = $index
              ) {
                @if (idx == projectLocal?.methodik?.length - 1) {
                  <span>{{ methodik | vocabulary:'method' }}</span
                  >.
                } @else if (idx == projectLocal?.methodik?.length - 2) {
                  <span>{{ methodik | vocabulary:'method' }}</span> und
                } @else {
                  <span>{{ methodik | vocabulary:'method' }}</span
                  >,
                }
              }
            </p>
          }
          @if (editMode) {
            <app-ci-multiselect
              class="project__method-select"
              [ngModel]="projectLocal.methodik"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="newBeraterMethod($event)"
              [items]="methodNames"
              [displayWith]="methodLabel"
              [placeholder]="'projects.searchPlaceholderMethod' | translate"
              [searchPlaceholder]="'projects.searchPlaceholderMethod' | translate"
              [ariaLabel]="'project.methodology' | translate"
              [countTemplate]="'ciSelect.selectedOfTotal' | translate"
              [removeChipTemplate]="'ciSelect.removeItem' | translate"
              [clearLabel]="'ciSelect.clearSelection' | translate"
              [emptyLabel]="'ciSelect.noMatch' | translate"
            ></app-ci-multiselect>
          }
        </div>
        <mat-divider class="project__divider"></mat-divider>
        @if (projectLocal?.tasks?.length > 0) {
          <div>
            <h4 class="project__headline">
              {{ 'project.tasks' | translate }}
            </h4>
            <p>
              <mat-accordion multi="false">
                @for (task of projectLocal.tasks; track idx; let idx = $index) {
                  <mat-expansion-panel
                    [expanded]="checkExpanded(idx)"
                    (opened)="toggleActiveTask(idx)"
                    class="project__expansion-panel"
                  >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        @if (validationResults[idx] && hasTaskErrors(validationResults[idx])) {
                          <mat-icon
                            class="project__task-error-icon"
                            [attr.aria-label]="'project.taskHasErrors' | translate">
                            error
                          </mat-icon>
                        }
                        {{ 'project.task' | translate }} {{ idx + 1 }} -
                        {{ task?.caption }}
                        @if (editMode && !exportMode && unsavedTasks[idx]) {
                          <span class="project__task-unsaved">{{ 'project.unsaved' | translate }}</span>
                        }
                      </mat-panel-title>
                      @if (validationResults[idx]) {
                        @let blockingCount = getBlockingMessages(validationResults[idx]).length;
                        @let hintCount = getHintMessages(validationResults[idx]).length;
                        @if (blockingCount > 0) {
                          <span
                            class="project__validation-badge project__validation-badge--error project__validation-badge--header"
                          >
                            {{ blockingCount }}
                            {{ (blockingCount === 1
                              ? 'project.validation.blockingOne'
                              : 'project.validation.blocking') | translate }}
                          </span>
                        }
                        @if (canSaveDraft && !task.skills?.length) {
                          <span class="project__skills-missing">{{ 'project.draft.skillsMissing' | translate }}</span>
                        }
                        @if (hintCount > 0) {
                          <span
                            class="project__validation-badge project__validation-badge--warn project__validation-badge--header"
                          >
                            {{ hintCount }}
                            {{ (hintCount === 1 ? 'general.note' : 'general.notes') | translate }}
                          </span>
                        }
                      }
                      @if (exportMode && exportable) {
                        <mat-checkbox
                          [checked]="
                            selectedExportIds.includes(
                              task.uuid || idx.toString()
                            )
                          "
                          [disabled]="
                            !selectedExportIds.includes(
                              task.uuid || idx.toString()
                            ) && !canSelectTask()
                          "
                          (change)="
                            toggleExportSelection(
                              task.uuid || idx.toString(),
                              $event.checked
                            )
                          "
                          (click)="$event.stopPropagation()"
                        ></mat-checkbox>
                      }
                      @if (!editMode && !exportMode && !lockedByOwnerDraft) {
                        <mat-icon
                          (click)="onToggleEditTask(idx)"
                          class="project__edit-icon"
                          type="button"
                          (mousedown)="$event.preventDefault()"
                          >edit
                        </mat-icon>
                      }
                    </mat-expansion-panel-header>
                    <div>
                      <div>
                        <div class="project__label-row">
                          <mat-label class="project__headline">{{
                            'project.title' | translate
                          }}</mat-label>
                          <ng-container
                            *ngTemplateOutlet="fieldInfo; context: { $implicit: 'tooltip.taskTitle', align: 'start' }"
                          ></ng-container>
                          @if (!editMode) {
                            <ng-container
                              *ngTemplateOutlet="fieldWarning; context: { $implicit: taskFinding(idx, 'caption'), align: 'start' }"
                            ></ng-container>
                          }
                        </div>
                        @if (!editMode) {
                          <p>{{ task?.caption }}</p>
                        } @else {
                          <mat-form-field class="project__formfield">
                            <textarea
                              #textAreaTask
                              #taskCaptionCtrl="ngModel"
                              matInput
                              type="text"
                              required
                              [(ngModel)]="task.caption"
                              name="taskCaption{{ idx }}"
                              (input)="onTaskInputChange(idx)"
                              (blur)="onTaskCaptionBlur(idx)"
                              appTrimmedLength
                              appCollapseWhitespace
                              [appTrimmedMin]="LIMITS.TASK_CAPTION_MIN"
                              [maxlength]="LIMITS.TASK_CAPTION"
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="2"
                              cdkAutosizeMaxRows="3"
                            >
                            </textarea>
                            <mat-hint>
                              {{ 'project.taskCaption.hint' | translate: {min: LIMITS.TASK_CAPTION_MIN, max: LIMITS.TASK_CAPTION} }}
                            </mat-hint>
                            <mat-hint align="end">
                              {{ captionLength(task?.caption) }}/{{ LIMITS.TASK_CAPTION }}
                            </mat-hint>
                            @if (taskCaptionCtrl.errors?.['minlength']) {
                              <mat-error>{{ 'project.validation.caption.tooShort' | translate }}</mat-error>
                            } @else if (taskCaptionCtrl.errors?.['maxlength']) {
                              <mat-error>{{ 'project.validation.caption.tooLong' | translate }}</mat-error>
                            } @else if (taskCaptionCtrl.errors?.['required']) {
                              <mat-error>{{ 'project.validation.caption.missing' | translate }}</mat-error>
                            }
                          </mat-form-field>
                        }
                      </div>
                      <div>
                        <div class="project__label-row">
                          <mat-label class="project__headline">{{
                            'project.description' | translate
                          }}</mat-label>
                          <ng-container
                            *ngTemplateOutlet="fieldInfo; context: { $implicit: 'tooltip.taskDescription', align: 'start' }"
                          ></ng-container>
                          @if (!editMode) {
                            <ng-container
                              *ngTemplateOutlet="fieldWarning; context: { $implicit: taskFinding(idx, 'details'), align: 'start' }"
                            ></ng-container>
                          }
                        </div>
                        @if (!editMode) {
                          <p>{{ task?.details }}</p>
                        } @else {
                          <mat-form-field class="project__formfield">
                            <textarea
                              #taskDetailsCtrl="ngModel"
                              matInput
                              type="text"
                              [required]="true"
                              [(ngModel)]="task.details"
                              name="taskDetails{{ idx }}"
                              [innerHTML]="task.details"
                              [value]="task.details"
                              (input)="onTaskInputChange(idx)"
                              (blur)="onTaskDetailsBlur(idx)"
                              appTrimmedLength
                              [appTrimmedMin]="LIMITS.TASK_DETAILS_MIN"
                              [maxlength]="LIMITS.TASK_DETAILS"
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="3"
                              cdkAutosizeMaxRows="5"
                            >
                            </textarea>
                            <mat-hint align="end">
                              {{ trimmedLength(task?.details) }}/{{ LIMITS.TASK_DETAILS }}
                            </mat-hint>
                            @if (taskDetailsCtrl.errors?.['required']) {
                              <mat-error>{{ 'project.validation.details.missing' | translate }}</mat-error>
                            } @else if (taskDetailsCtrl.errors?.['minlength']) {
                              <mat-error>{{ 'project.validation.details.tooShort' | translate }}</mat-error>
                            } @else if (taskDetailsCtrl.errors?.['maxlength']) {
                              <mat-error>{{ 'project.validation.details.tooLong' | translate }}</mat-error>
                            }
                          </mat-form-field>
                          @if (validationResults[idx]) {
                            @let hints = getHintMessages(validationResults[idx]);
                            @if (hints.length > 0) {
                              <ul class="project__task-hints">
                                @for (msg of hints; track msg.key + '-' + $index) {
                                  <li>{{ msg.key | translate: msg.params }}</li>
                                }
                              </ul>
                            }
                          }
                        }
                      </div>
                      @if (!exportMode) {
                        <div class="project__container">
                          <div class="project__label-row">
                            <mat-label class="project__headline">{{
                              'project.skills' | translate
                            }}</mat-label>
                            <ng-container
                              *ngTemplateOutlet="fieldInfo; context: { $implicit: 'tooltip.taskSkills', align: 'start' }"
                            ></ng-container>
                            @if (!editMode) {
                              <ng-container
                                *ngTemplateOutlet="fieldWarning; context: { $implicit: taskFinding(idx, 'skills'), align: 'start' }"
                              ></ng-container>
                            }
                          </div>
                          @if (canSaveDraft && !editMode && !task.skills?.length) {
                            <p class="project__skills-missing-text">{{ 'project.draft.skillsMissingText' | translate }}</p>
                          } @else {
                            <app-skill-select
                              [beraterSkills]="task.skills"
                              [skillList]="skillList"
                              [editMode]="editMode"
                              [active]="checkExpanded(idx)"
                              (skillSaved)="reloadSkills()"
                              (changedBeraterSkills)="
                                newBeraterSkills($event, idx);
                                onTaskInputChange(idx)
                              "
                              [searchLabel]="'projects.searchPlaceholderSkill'"
                            >
                            </app-skill-select>
                          }
                          @if (editMode && validationResults[idx]) {
                            @for (msg of getSkillErrors(validationResults[idx]); track msg.key) {
                              <mat-error>{{ msg.key | translate: msg.params }}</mat-error>
                            }
                          }
                        </div>
                      }
                      @if (exportMode && twoPagerMode) {
                        <div class="project__container">
                          <div class="project__label-row">
                            <mat-label class="project__headline">{{
                              'project.skills' | translate
                            }}</mat-label>
                          </div>
                          @if (skillBudgetReached && task.skills?.length) {
                            <div class="export-limit-hint">
                              <mat-icon>info</mat-icon>
                              <span>{{ 'consultant.twoPager.skillLimitReached' | translate }}</span>
                            </div>
                          }
                          @if (task.skills?.length) {
                            @for (skill of task.skills; track skill.id) {
                              <div class="project__export-row">
                                @if (exportable) {
                                <mat-checkbox
                                  [checked]="selectedSkillIds.includes(skill.id)"
                                  [disabled]="!canSelectTaskSkill(skill)"
                                  (change)="toggleTaskSkill(skill.id, $event.checked)"
                                  (click)="$event.stopPropagation()"
                                ></mat-checkbox>
                                }
                                <span>{{ skill | vocabulary:'skill' }}</span>
                              </div>
                            }
                          } @else {
                            <p>{{ 'projects.noSkillsForTask' | translate }}</p>
                          }
                        </div>
                      }
                    </div>
                    @if (editMode) {
                      <div class="project__task-actions">
                        <button
                          mat-stroked-button
                          type="button"
                          class="project__remove-task-button"
                          (click)="openDeleteModal(idx)"
                        >
                          <mat-icon aria-hidden="true">delete</mat-icon>
                          {{ 'project.button.removeTask' | translate }}
                        </button>
                        @if (!exportMode) {
                          <button
                            mat-stroked-button
                            type="button"
                            class="project__task-save-button"
                            disabledInteractive
                            [disabled]="taskSaveBlocked(idx)"
                            [matTooltip]="taskSaveHover(idx)"
                            matTooltipClass="project__save-tooltip project__task-save-tooltip"
                            [attr.aria-label]="'project.taskSave.ariaLabel' | translate: { nr: idx + 1 }"
                            (click)="saveTask(idx)"
                          >
                            {{ 'project.taskSave.button' | translate }}
                          </button>
                        }
                      </div>
                    }
                  </mat-expansion-panel>
                }
              </mat-accordion>
            </p>
          </div>
        } @else {
          @if (editMode) {
            <h4 class="project__headline">
              {{ 'project.tasks' | translate }}
            </h4>
          }
          <!--
            NP20-892: Aufgaben-Liste ist Pflicht (BE @NotEmpty). Der Badge blockiert
            den Speichern-Button und ist deshalb als 'error' markiert — nicht mehr
            als bloßer Warnhinweis.
          -->
          <div class="project__label-row">
            <lib-badge
              [size]="'medium'"
              [text]="'project.taskMissing' | translate"
              [type]="'error'"
            ></lib-badge>
            <ng-container
              *ngTemplateOutlet="fieldWarning; context: { $implicit: tasksSectionFinding }"
            ></ng-container>
          </div>
        }
        @if (editMode) {
          <div class="project__button-group">
            <button mat-flat-button type="button" (click)="createNewTask()">
              {{ 'project.button.createNewTask' | translate }}
            </button>
          </div>
        }
        @if (canSaveDraft && !exportMode) {
          <!-- Icon und Text als genau zwei Flex-Items, sonst bricht der Satz in Spalten auf. -->
          <p class="project__draft-note">
            <mat-icon aria-hidden="true">info</mat-icon>
            <span [innerHTML]="'project.draft.note' | translate"></span>
          </p>
        }
      </div>
      <!-- NP20-822: Ein Projekt mit vielen Aufgaben ist lang; Abbrechen und Speichern bleiben
           beim Bearbeiten am unteren Rand erreichbar und rasten am Ende der Karte ein. -->
      @if (editMode && !exportMode) {
        <div class="sticky-save project__sticky-save" role="group" [attr.aria-label]="'general.sectionActionsEnd' | translate">
          <div class="project__save-actions">
            <ng-container *ngTemplateOutlet="saveButtons"></ng-container>
          </div>
        </div>
      }
      <ng-template #saveButtons>
        <button
          mat-stroked-button
          type="button"
          [matTooltip]="'project.cancelHover' | translate"
          matTooltipClass="project__save-tooltip"
          (click)="onCancelEdit()"
        >
          {{ 'general.cancel' | translate }}
        </button>
        @if (canSaveDraft) {
          <button
            mat-stroked-button
            type="button"
            class="project__draft-button"
            [disabled]="isSaving"
            [matTooltip]="'project.draft.saveHover' | translate"
            matTooltipClass="project__save-tooltip"
            (click)="saveDraft()"
          >
            {{ 'project.draft.save' | translate }}
          </button>
        }
        <button
          mat-flat-button
          color="primary"
          type="button"
          disabledInteractive
          [disabled]="projectForm.invalid || releaseBlocked"
          [matTooltip]="primarySaveHover"
          matTooltipClass="project__save-tooltip"
          (click)="onPrimarySave(projectForm)"
        >
          {{ (canSaveDraft ? 'project.draft.release' : 'general.save') | translate }}
        </button>
      </ng-template>
    </form>
  </mat-card-content>
</mat-card>

<app-modal
  modalId="deleteProject"
  [title]="'project.modal.title'"
  [text]="'project.modal.text'"
  [(visible)]="showModal"
  [showButtons]="true"
  (save)="deleteTask(currentIdx)"
  [showClose]="true"
  [saveText]="'general.delete'"
></app-modal>

<ng-template #fieldInfo let-textKey let-align="align">
  <app-field-hint [text]="textKey | translate" [align]="align ?? 'end'"></app-field-hint>
</ng-template>

<ng-template #fieldWarning let-finding let-align="align">
  @if (finding) {
    <app-field-hint
      variant="warn"
      [align]="align ?? 'end'"
      [text]="finding.reasonKey | translate: finding.reasonParams"
      [hintLabel]="
        (finding.labelKey | translate) +
        ': ' +
        (finding.reasonKey | translate: finding.reasonParams)
      "
    ></app-field-hint>
  }
</ng-template>
